import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, unref as _unref, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "SageBackup" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { style: {"position":"fixed","z-index":"9999"} }, null, -1)
const _hoisted_3 = {
  key: 0,
  class: "content-container"
}
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "loading" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "loader" })
], -1)
const _hoisted_5 = [
  _hoisted_4
]
const _hoisted_6 = {
  key: 1,
  class: "content-container"
}
const _hoisted_7 = { class: "top-content" }
const _hoisted_8 = { class: "center-dropdown-table-container" }
const _hoisted_9 = { class: "center-dropdown-table" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("tr", null, [
  /*#__PURE__*/_createElementVNode("td", null, [
    /*#__PURE__*/_createElementVNode("div", {
      class: "nudge",
      style: {"display":"flex","justify-content":"center","align-items":"center"}
    }, " Upload Sage Backup File: ")
  ])
], -1)
const _hoisted_11 = { class: "search-with-button" }
const _hoisted_12 = ["title"]
const _hoisted_13 = ["disabled"]
const _hoisted_14 = ["title", "disabled"]
const _hoisted_15 = { class: "table-container" }
const _hoisted_16 = { class: "w3-container" }
const _hoisted_17 = { class: "w3-light-grey" }

import { ref, onMounted, inject, watch, computed } from "vue";
import { apiLoggerKey } from "@/types/ServiceKeys";
import {
    SageBackupHelper,
    cols,
    labels,
    defaultSortCols,
    defaultSortOrders
} from "@/services/helpers/SageBackupHelper";
import IBackupFile from "@/Interfaces/SageBackup/IBackupFile";
import Table from "@/components/TablePersistentChecking.vue";
import log from "loglevel";
import { AxiosResponse, AxiosError } from "axios";
import useNotifierWithErrFormatter from "@/services/composables/NotifierWithErrFormatter";

const fileName = "SageBackup.vue";

export default /*#__PURE__*/_defineComponent({
  __name: 'SageBackup',
  setup(__props) {

const Logger = inject(apiLoggerKey);
const infoError = ref();
const backupServices = new SageBackupHelper();
const isLoading = ref(false);
const isUploading = ref(false);
const showGetBackupFilesInfoError = ref();
const selectedFile = ref<File>();
const fileInput = ref<HTMLInputElement>();
const uploadFileName = ref<string>();
const lastUploadFileName = ref<string>();
const fileSize = ref<number>();
const lastModified = ref<Date>();
const p = ref(0);
const uploadStatusClass = ref("w3-light-grey");
const idCounter = ref(0);
const greenHighlight = ref(false);
const backupFiles = ref<IBackupFile[]>();
const showDuplicate = computed(() => {
    return backupFiles.value?.map((file: IBackupFile) => file.FileName).includes(uploadFileName.value!) || false
});
const fileSelectionTitle = computed(() => {
    if (uploadFileName.value) {
        return showDuplicate.value
            ? `A backup file with the name '${uploadFileName.value}' already exists. Duplicate file names are not permitted.`
            : 'Change backup file to upload.'
    } else {
        return 'Select a backup file to upload.';
    }
});
const fileUploadTitle = computed(() => {
    if (uploadFileName.value) {
        return showDuplicate.value
            ? `A backup file with the name '${uploadFileName.value}' already exists. Duplicate file names are not permitted.`
            : `Upload Sage backup file '${uploadFileName.value}'`
    } else {
        return 'You must select a backup file before attempting to upload.';
    }
});

onMounted(() => {
    log.trace("onMounted() Sage Backup");
    document.title = 'Sage Backup - UV';
    GetBackups();
});
async function GetBackups(reloadPage: boolean = true) {
    if (reloadPage) isLoading.value = true;
    else backupFiles.value = undefined;

    await backupServices.GetBackups()
        .then(async (backups: AxiosResponse<IBackupFile[]>) => {
            backupFiles.value = backups.data;

            lastUploadFileName.value = `${uploadFileName.value}`;
            uploadFileName.value = "";
            HighlightGreen();
        })
        .catch((error: any) => {
            showGetBackupFilesInfoError.value = error;
            backupFiles.value = [];
            useNotifierWithErrFormatter().error({ errorType: 'Getting Backup Files', error });
        })
        .finally(() => {
            isLoading.value = false;
        })
}
function ChooseFile() {
    const name = ChooseFile.name;
    log.debug(`${name}()`);
    if (!fileInput.value) {
        return useNotifierWithErrFormatter().error({
            errorType: 'Choosing a file',
            error: new ReferenceError('fileInput not assigned'),
        })
    }
    // Get the selected file
    selectedFile.value = fileInput.value.files?.[0];

    log.debug(`${name}()\nSelected file: ${selectedFile.value}`)

    // Access file properties
    uploadFileName.value = selectedFile.value?.name as string;
    fileSize.value = selectedFile.value?.size as number; // Get the file size (in bytes)
    const lastModifiedTS = selectedFile.value?.lastModified;
    lastModified.value = lastModifiedTS ? new Date(lastModifiedTS) : undefined;
}
function triggerFileInput() {
    fileInput?.value?.click();
}
async function UploadFile() {
    const name = UploadFile.name;
    const Class = fileName + "/" + name;
    var Message = `Uploading backup file: ${uploadFileName.value}`;

    // Close open error and note
    ResetError();

    // Reset progress bar
    backupServices.percentage.value = 0;

    if (selectedFile.value) {
        selectedFile.value = fileInput.value?.files![0] || undefined;
        log.debug(`${name}()\nSelected file: ${selectedFile.value}`)
        // Display the file information in alert before proceeding
        if(confirm(`You are about to upload the following file:\nName: ${uploadFileName.value}\nSize: ${fileSize.value} bytes (${Math.round(((fileSize.value ? fileSize.value : 0) / 1000000) * 100) / 100} MB)\nLast Modified: ${lastModified.value}`)) {
            if (selectedFile.value && uploadFileName.value != undefined) {
                // Create a new FileReader
                var reader = new FileReader();
        
                // Add an event listener to handle when the file is loaded
                reader.onload = async (event: ProgressEvent<FileReader>) => {
                    if (event && event.target) {
                        // Use a regex to remove data url part
                        const base64String: string = (reader.result! as string)
                            .replace('data:', '')
                            .replace(/^.+,/, '');
        
                        // Upload file
                        isUploading.value = true;
                        await backupServices.BackupFile(uploadFileName.value!, fileSize.value!, base64String)
                            .then(async (response: AxiosResponse<any>) => {
                                isUploading.value = false;
                                lastUploadFileName.value = `${uploadFileName.value}`;
                                ResetFileSelector();
                                useNotifierWithErrFormatter().success({ msg: lastUploadFileName.value + " has been uploaded successfully." });
                                await GetBackups(false);
                            })
                            .catch((error: any) => {
                                if (error instanceof AxiosError) {
                                    if (error.response?.status == 409) {
                                        useNotifierWithErrFormatter().warn({msg: "A backup file with the name " + uploadFileName.value + " already exists." })
                                    }
                                    else {
                                        useNotifierWithErrFormatter().error({ errorType: 'Uploading Backup File', error });
                                    }
                                    backupServices.percentage.value = -1;
                                }
                            }).finally(() => {
                                isUploading.value = false;
                            });
                    }
                };
                reader.onerror = (error: ProgressEvent<FileReader>) => {
                    Message = `(Error) ${Message}: ${error}`;
                    log.error(Message);
                    Logger?.LogError(Message, Class);
                };
        
                reader.readAsDataURL(selectedFile.value);
            } else {
                // Handle the case when no file is selected
                log.debug(`${name}()\nNo file selected.`);
            }
        }
    } else {
        alert("No file selected.");
    }
}
function ResetError() {
    infoError.value = undefined;
}
function ResetFileSelector() {
    const name = ResetFileSelector.name;
    log.trace(`${name}()`);

    selectedFile.value = undefined;
    uploadFileName.value = undefined;
    if (fileInput.value) fileInput.value.value = '';
}
function HighlightGreen() {
    greenHighlight.value = true;

    setTimeout(() => {
        greenHighlight.value = false;
        idCounter.value += 1;
    }, 2000); // milliseconds
    
    idCounter.value += 1;
}
watch(() => backupServices.percentage.value, (newVal) => {
        log.error('watch()');
        p.value = newVal;
        switch (newVal) {
            case 100:
                p.value = 100;
                uploadStatusClass.value = "w3-green";
                break;
            case -1:
                p.value = 100;
                uploadStatusClass.value = "w3-red";
                break;
            case 0:
                p.value = 0;
                uploadStatusClass.value = "w3-light-grey";
                break;
        }
    }
)
watch(() => selectedFile.value, (newVal) => {
        if (!newVal) uploadFileName.value = undefined;
    }
)

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    (isLoading.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, _hoisted_5))
      : (_openBlock(), _createElementBlock("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("tbody", null, [
                  _hoisted_10,
                  _createElementVNode("tr", null, [
                    _createElementVNode("td", null, [
                      _createElementVNode("div", null, [
                        _createElementVNode("span", _hoisted_11, [
                          _createElementVNode("div", null, [
                            _createElementVNode("button", {
                              onClick: triggerFileInput,
                              title: fileSelectionTitle.value,
                              class: _normalizeClass(`left-button ${showDuplicate.value ? 'errored-button' : ''}`),
                              style: {"border-right":"solid var(--primary-color-dark)","padding-left":"3rem","padding-right":"3rem"}
                            }, _toDisplayString(uploadFileName.value ? `Selected '${uploadFileName.value}'` : 'Select file to upload'), 11, _hoisted_12),
                            _createElementVNode("input", {
                              ref_key: "fileInput",
                              ref: fileInput,
                              type: "file",
                              name: "fileUpload",
                              onChange: _cache[0] || (_cache[0] = () => ChooseFile()),
                              disabled: isUploading.value,
                              style: {"display":"none"}
                            }, null, 40, _hoisted_13),
                            _createElementVNode("button", {
                              onClick: _cache[1] || (_cache[1] = ($event: any) => (UploadFile())),
                              title: fileUploadTitle.value,
                              disabled: !selectedFile.value || isUploading.value || showDuplicate.value,
                              class: "right-button",
                              style: _normalizeStyle(`padding-left: 3rem; padding-right: 3rem; ${showDuplicate.value ? 'border-color: crimson; color: rgba(255, 0, 0, 0.4);' : ''}`)
                            }, " Upload ", 12, _hoisted_14)
                          ])
                        ])
                      ])
                    ])
                  ])
                ])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_15, [
            _createElementVNode("div", _hoisted_16, [
              _createElementVNode("div", _hoisted_17, [
                (!!selectedFile.value)
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 0,
                      class: _normalizeClass(uploadStatusClass.value),
                      style: _normalizeStyle(`height:24px; width:${p.value}%; transition: var(--tran-2);`)
                    }, null, 6))
                  : _createCommentVNode("", true)
              ]),
              _createVNode(Table, {
                Rows: backupFiles.value,
                Cols: _unref(cols),
                Labels: _unref(labels),
                DefaultSortCols: _unref(defaultSortCols),
                DefaultSortOrders: _unref(defaultSortOrders),
                HasError: !!showGetBackupFilesInfoError.value
              }, {
                Modified: _withCtx((props) => [
                  _createElementVNode("div", {
                    class: _normalizeClass((props.value.FileName === lastUploadFileName.value) && greenHighlight.value ? 'highlight-green' : '')
                  }, _toDisplayString(props.value.Modified), 3)
                ]),
                FileName: _withCtx((props) => [
                  _createElementVNode("div", {
                    class: _normalizeClass((props.value.FileName === lastUploadFileName.value) && greenHighlight.value ? 'highlight-green' : '')
                  }, _toDisplayString(props.value.FileName), 3)
                ]),
                _: 1
              }, 8, ["Rows", "Cols", "Labels", "DefaultSortCols", "DefaultSortOrders", "HasError"])
            ])
          ])
        ]))
  ]))
}
}

})